import React from 'react'
import {Card, CardBody, Form} from "reactstrap"

class CheckPageHome extends React.Component {
    constructor(props) {
        super(props)

        this.textInput = React.createRef()

        this.state = {
            value: ''
        }
    }

    _handleSubmit = (e) => {
        e.preventDefault()

        const {onChangeId} = this.props
        const {value} = this.state

        if (typeof onChangeId === 'function') {
            if (value && value.length) onChangeId(value)
        }
    }

    _handleChangeInput = (e) => {
        const {value} = e.target

        this.setState({
            value: value
        })
    }

    componentDidMount() {
        this.textInput.current.focus()
    }

    render() {
        const {value} = this.state
        
        return (
            <div className='PrintPage CheckPageHome'>
                <Card>
                    <div className="card-header bg-success text-white header-elements-inline">
                        <h1 className="card-title">QC Hoàn Thành 2D</h1>
                    </div>
                    <CardBody>
                        <Form className='d-flex justify-content-center' onSubmit={this._handleSubmit}>
                            <input
                                ref={this.textInput}
                                className='InputSearch form-control'
                                name='barcodeNumber'
                                value={value}
                                onChange={this._handleChangeInput}
                                autoFocus
                                placeholder="Nhập hoặc quét barcode vào..."
                            />
                        </Form>
                    </CardBody>
                </Card>
            </div>
        )
    }
}

export default CheckPageHome
